import { render } from "./AdminSubnav.vue?vue&type=template&id=6b649b28"
import script from "./AdminSubnav.vue?vue&type=script&lang=js"
export * from "./AdminSubnav.vue?vue&type=script&lang=js"

import "./AdminSubnav.vue?vue&type=style&index=0&id=6b649b28&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__